// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { getSettings } from '../../helpers/data-helper';
import { PriorityResilienceClustersDefaultSettings } from './widgets-default-settings';
import ClassificationTrendsBase from './ClassificationTrendsBase';
import { WidgetCode } from './widgetCodes';
import { getReportWidgetData } from '../../services/WidgetDataService';

function PriorityResilienceClusters({ limit, settings }) {
  const {
    title,
    info,
    resilienceType,
    reportsPercent,
    previousPeriodReportsPercent,
    currentPeriodReportsPercent,
    noDataLabel,
  } = getSettings(settings, PriorityResilienceClustersDefaultSettings);

  const fetchTrendsFunc = () =>
    getReportWidgetData(WidgetCode.priorityResilienceClusters);

  return (
    <ClassificationTrendsBase
      trendsFetchFunc={fetchTrendsFunc}
      limit={limit}
      title={title}
      info={info}
      noDataLabel={noDataLabel}
      classificationType={resilienceType}
      previousPeriod={previousPeriodReportsPercent}
      currentPeriod={currentPeriodReportsPercent}
      reportsPercent={reportsPercent}
      widgetName="PriorityResilienceClusters"
    />
  );
}

PriorityResilienceClusters.propTypes = {
  limit: PropTypes.number,
  settings: PropTypes.object,
};

export default PriorityResilienceClusters;
